import { FieldErrors } from "react-hook-form";
import { FormTypes } from "../../types/FormTypes";
import { error } from "console";

interface IErrors {
  errors: FieldErrors<FormTypes>;
}

function Errors(props: IErrors) {
  const { errors } = props;

  return (
    <>
      {Object.keys(errors).length ? (
        <p className="text-danger mt2">Please correct form values</p>
      ) : null}
      {/* {errors.travelDistance && (
        <span className="text-danger">{`Please check input Travel Distance ${errors.travelDistance.type}`}</span>
      )}

      {errors.driveSystemBelt &&
      errors.driveSystemChain &&
      errors.driveSystemLeadScrew &&
      errors.driveSystemBallScrew ? (
        <p className="text-danger">Please select at least one drive system</p>
      ) : null}

      {errors.payloadMass && (
        <p className="text-danger">{`Please check input Mass ${errors.payloadMass.type}`}</p>
      )}
      {errors.payloadXOffset && (
        <p className="text-danger">{`Please check input X Offset ${errors.payloadXOffset.type}`}</p>
      )}
      {errors.payloadYOffset && (
        <p className="text-danger">{`Please check input Y Offset ${errors.payloadYOffset.type}`}</p>
      )}
      {errors.payloadZOffset && (
        <p className="text-danger">{`Please check input Z Offset ${errors.payloadZOffset.type}`}</p>
      )}

      {errors.externalForceAppliedForce1 && (
        <p className="text-danger">{`Please check input Applied Force ${errors.externalForceAppliedForce1.type}`}</p>
      )}
      {errors.externalForceAppliedForceX1 && (
        <p className="text-danger">{`Please check input Applied Force X ${errors.externalForceAppliedForceX1.type}`}</p>
      )}
      {errors.externalForceAppliedForceY1 && (
        <p className="text-danger">{`Please check input Applied Force Y ${errors.externalForceAppliedForceY1.type}`}</p>
      )}
      {errors.externalForceAppliedForceZ1 && (
        <p className="text-danger">{`Please check input Applied Force Z ${errors.externalForceAppliedForceZ1.type}`}</p>
      )}
      {errors.externalForceMomentX1 && (
        <p className="text-danger">{`Please check input Moment X ${errors.externalForceMomentX1.type}`}</p>
      )}
      {errors.externalForceMomentY1 && (
        <p className="text-danger">{`Please check input Moment Y ${errors.externalForceMomentY1.type}`}</p>
      )}
      {errors.externalForceMomentZ1 && (
        <p className="text-danger">{`Please check input Moment Z ${errors.externalForceMomentZ1.type}`}</p>
      )}

      {errors.adjustmentFactor && (
        <p className="text-danger">{`Please check input Adjustment Factor ${errors.adjustmentFactor.type}`}</p>
      )}

      {errors.maxAcceleration && (
        <p className="text-danger">{`Please check input Max Acceleration ${errors.maxAcceleration.type}`}</p>
      )}
      {errors.maxVelocity && (
        <p className="text-danger">{`Please check input Max Velocity ${errors.maxVelocity.type}`}</p>
      )}
      {errors.cycleStroke && (
        <p className="text-danger">{`Please check input Cycle Stroke ${errors.cycleStroke.type}`}</p>
      )}
      {errors.strokeTime && (
        <p className="text-danger">{`Please check input Stroke Time ${errors.strokeTime.type}`}</p>
      )}
      {errors.timeAtMaxV && (
        <p className="text-danger">{`Please check input Time @ Max V ${errors.timeAtMaxV.type}`}</p>
      )}
      {errors.strokeAtMaxV && (
        <p className="text-danger">{`Please check input Stroke @ Max V ${errors.strokeAtMaxV.type}`}</p>
      )}

      {errors.cyclesCycles && (
        <p className="text-danger">{`Please check input Cycles ${errors.cyclesCycles.type}`}</p>
      )}
      {errors.cyclesCyclesDuration && (
        <p className="text-danger">Selection required</p>
      )}
      {errors.cyclesMinutes && (
        <p className="text-danger">{`Please check input Travel Distance ${errors.cyclesMinutes.type}`}</p>
      )}
      {errors.cyclesMinutesDuration && (
        <p className="text-danger">Selection required</p>
      )}
      {errors.cyclesDays && (
        <p className="text-danger">{`Please check input Travel Distance ${errors.cyclesDays.type}`}</p>
      )}
      {errors.cyclesDaysDuration && (
        <p className="text-danger">Selection required</p>
      )}

      {errors.orientation && (
        <p className="text-danger">Please select an option</p>
      )}

      {errors.maxSpeed && (
        <p className="text-danger">{`Please check input Travel Distance ${errors.maxSpeed.type}`}</p>
      )}
      {errors.maxAcceleration && (
        <p className="text-danger">{`Please check input Travel Distance ${errors.maxAcceleration.type}`}</p>
      )}
      {errors.maxDeceleration && (
        <p className="text-danger">{`Please check input Travel Distance ${errors.maxDeceleration.type}`}</p>
      )} */}
    </>
  );
}

export default Errors;
